import { Config } from "../config";

export async function submitFeedback(data:any) {
    const submitData = {
        email: data.email,
        domain: 'de',
        feedbackType: "General Feedback",
        websiteName: 'incluway',
        status: "In Progress",
        feedback_message: data.feedbackMessage,
      };

      const response = await fetch(`${Config.BACKEND_URL}/feedback`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            data: submitData,
          },
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to submit feedback");
      }
      return await response.json();
}